module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/interaktivniMapa-5a7683a5607f094f404dedb31c4414b4.png";